import { useEffect, useState } from 'react'
import { Button } from 'theme-ui'

interface AgeVerificationPopupProps {
  onVerified: () => void
}

const AgeVerificationPopup: React.FC<AgeVerificationPopupProps> = ({
  onVerified,
}) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      const ageVerified = localStorage.getItem('ageVerified');
      if (!ageVerified || ageVerified === 'false') {
        setVisible(true);
      }
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      setVisible(true); 
    }
  }, []);

  const handleYes = () => {
    localStorage.setItem('ageVerified', 'true')
    setVisible(false)
    onVerified()
  }

  const handleNo = () => {
    localStorage.setItem('ageVerified', 'false')
    window.location.href = 'https://www.penguin-aa.com/'
  }

  if (!visible) return null

  return (
    <div style={overlayStyle}>
      <div style={popupStyle}>
        <h2>Are you 18 or older?</h2>
        <div style={buttonContainerStyle}>
          <Button onClick={handleYes}>Yes</Button>
          <Button onClick={handleNo}>No</Button>
        </div>
      </div>
    </div>
  )
}

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'linear-gradient(180deg, rgba(0,0,0,0.9), rgba(0,0,0,0.7))',
  backdropFilter: 'blur(5px)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  animation: 'fadeIn 0.3s ease-in-out',
}

const popupStyle: React.CSSProperties = {
  background: 'white',
  padding: '20px',
  gap: '20px',
  borderRadius: '10px',
  textAlign: 'center',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
  width: '90%',
  maxWidth: '400px',
  animation: 'scaleIn 0.3s ease-in-out',
}

const buttonContainerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  gap: '20px',
}

export default AgeVerificationPopup
